import styled from "styled-components";
import { primaryColor, primaryColorHover } from "../../../../config/constants";
import { Link } from "react-router-dom";

export const Title = styled.h2`
  margin: 0 0 20px;
  font-size: ${({ fontSize }) => (fontSize ? fontSize : "26px")};
  text-align: center;
`;
export const CreateStationDiv = styled.div`
  margin: 10px auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const CreateStationLink = styled(Link)`
  margin: 10px auto;
  padding: 10px;
  font-size: 14px;
  color: #000;
  border: 2px solid ${primaryColor};
  outline: none;
  text-decoration: none;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.15s ease-in-out;
  &:hover {
    background-color: ${primaryColor};
    color: #fff;
  }
`;
export const TableContainer = styled.div`
  margin: 0 auto;
  width: 1000px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const TableTitle = styled.p`
  width: 200px;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
`;
export const StationContainer = styled.div`
  margin: 5px auto;
  padding: 10px 0;
  width: 1000px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
`;
export const StationInfo = styled.p`
  width: 200px;
  font-size: 14px;
  text-align: center;
`;
export const ActionCell = styled.div`
  width: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;
export const VersionSelect = styled.select`
  width: 90px;
  height: 30px;
  font-size: 14px;
  border-radius: 5px;
  outline: none;
  cursor: pointer;
`;
export const ActionButton = styled.button`
  padding: 6px 14px;
  font-size: 13px;
  color: #fff;
  background-color: ${({ variant }) => (variant === "cancel" ? "#888" : primaryColor)};
  outline: none;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.15s ease-in-out;
  &:hover {
    background-color: ${({ variant }) => (variant === "cancel" ? "#666" : primaryColorHover)};
  }
`;
